"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _adUtil = require("../../../helpers/adUtil");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var AdStatus = function AdStatus(_ref) {
  var adStatus = _ref.adStatus;
  if ((0, _adUtil.isAdInactive)(adStatus)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.AdStatusWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.AdStatusText, {
        children: "an\xFAncio inativo"
      })
    });
  }
  return null;
};
AdStatus.propTypes = {
  adStatus: _propTypes.string.isRequired
};
var _default = exports["default"] = AdStatus;